const selectorsToHandle = {
	clickToCall: '[data-click-to-call] a[href*="tel:"]',
	compareId: '[data-compare-id]',
	dialogClose: '.modal-content .modal-header .close, [data-dialog-close]',
	dialogBackdropClose: '.modal-backdrop',
	getDirectionsForm: "[data-widget-name='directions-form'] form",
	getDirections:
		"[data-widget-name='ws-contact'] .direction-link a, [data-widget-name='map-dynamic'] a[data-ws-tracking-directions]",
	formInitiation: `[data-form-tracking-id] input,
	[data-form-tracking-id] select,
	[data-form-tracking-id] textarea`,
	formOnPage: "[data-form-tracking-id], form input[name='userSessionId']",
	formPaymentCalc: "[data-widget-name='calculator-payment'] form",
	formSubmission: `[data-form-tracking-id]:not([data-form-tracking-id="SMS_SHARE"],[data-form-tracking-name="inventory-search-lead"])  [type=submit],
	[data-form-tracking-id="PREQUAL"] .finance-prequal-submit`,
	incentiveId: '[data-incentive-id]',
	incentiveLabel: '.vehicle-card dl.pricing-detail [role="button"]',
	linkClick: `a[href],
	a[data-href],
	a.facetmulti-collapse-toggle,
	button`,
	// Mobile "Close filters" button dismisses the filters overlay.
	dialogCloseFilters: '.modal-content button[aria-label="Close filters"]',
	linksShareId: '[data-links-share-link-id]',
	mapTypeId: '[data-map-type-id]',
	navigationId: '[data-navigation-id]',
	specialsIncentiveId: `[data-widget-name='specials-listing'] .special .ddc-link-primary.dialog,
	[data-widget-name='specials-listing'] .special .ddc-nav-inline .dialog`,
	// See v9/media/js/ddc-promotions/tracking.js. This is just for storing the selectors used there as a reference.
	specialsEvents: `.promotion-body [data-promo-tracking-action],
	.promotion-details-content[data-promo-id] [data-promo-tracking-action]`,
	slideType: '[data-slide-type]',
	// The second alternative covers social icons in CMS-authored content, where
	// data-social-header-button-id cannot be relied on: it would have to be
	// hand-added to every anchor on every account, and is silently lost whenever
	// the widget is edited. Scoping to a widget class instead needs one CMS
	// value, the same hook the tagging rules already key on.
	//
	// The trailing `a[href]` is required, not tidiness: jQuery delegation sets
	// currentTarget to the matched element, and socialHeader reads its `href`.
	// Matching the container instead would emit the event with url undefined.
	socialHeaderButtonId: `[data-social-header-button-id],
	.tagging-contact-us-today-social a[href]`,
	typedSearchInit: `.facetmulti input[type="search"],
.facetmulti button.facetmulti-freeform-search-submit`,
	vehicleCompare:
		'.vlp .item-compare input[type="checkbox"], .vehicle-card-footer input[type="checkbox"]',
	vin: `[data-showroom-listing-vehicle-id],
	[data-modelselector-vehicle-id],
	.inventoryList .hproduct .photo,
	.inventoryList .hproduct .url,
	.inventoryList .hproduct .video,
	.inventory-similar-default .hproduct .media a,
	.inventory-similar-default .hproduct .url,
	.inventory-similar-default .hproduct .view-link,
	.srp .ws-inv-listing .img-container img,
	.srp .ws-inv-listing .vehicle-card-title a,
	.srp .ws-inv-listing .more-details-link`,
	video: 'video',
	incentiveFacet: '.incentives-search-default .facets-container input',
	searchFacet: `.facetmulti input[type="checkbox"],
	.facet-breadcrumb-list input[type="checkbox"],
	.facetmulti-item input[type="radio"]`,
	searchFacetVlpSlider: '.facet-user-range-input-slider.noUi-target'
};

const getSelectorsToHandle = (win) => {
	// extra safe as this property should always be defined
	const formChangeTypes = win?.DDC?.WidgetData?.['ws-tracking']
		?.formChangeTypes || ['select'];

	return {
		...selectorsToHandle,
		...(typeof win !== 'undefined' && {
			formChange: formChangeTypes
				?.map?.((type) => `form ${type}`)
				.join(',')
		})
	};
};

export default getSelectorsToHandle;
